export default {
  "site.name": "Kakobuy Polska",
  "site.tagline": "Forum",
  "site.description": "Największa polska baza wiedzy o Kakobuy Spreadsheet",
  "nav.home": "Strona Główna",
  "nav.spreadsheet": "Spreadsheet",
  "nav.categories": "Kategorie",
  "nav.guides": "Poradniki",
  "nav.safety": "Bezpieczeństwo",
  "nav.faq": "FAQ",
  "nav.article": "Artykuły",
  "cta.spreadsheet": "Przejdź do Kakobuy Spreadsheet",
  "cta.buyNow": "Kup Teraz",
  "cta.viewGuide": "Zobacz poradnik",
  "cta.checkList": "Sprawdź pełną listę produktów",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
  "footer.disclaimer": "Kakobuy Polska Forum jest niezależną platformą informacyjną. Nie jesteśmy powiązani z Kakobuy.",
  "footer.privacy": "Polityka Prywatności",
  "footer.terms": "Regulamin",
  "footer.safety": "Bezpieczeństwo",
  "external.disclaimer": "Link zewnętrzny – otwiera się w nowej karcie"
}